export default __webpack_public_path__ + "static/media/custom-signup.9a0e0f9a.png";